import classes from '../TextWithCrown.module.scss';

import { CrownSvg } from './CrownSvg';

export type CrownLetterProps = {
  letter: string;
  isCrown: boolean;
  crownFill?: string;
  style?: React.CSSProperties;
  crownStyle?: React.CSSProperties;
};

export function CrownLetter({ letter, isCrown, crownFill, style, crownStyle }: CrownLetterProps) {
  return (
    <span className={classes.crownLetter} style={style}>
      {isCrown && (
        <div className={classes.crown} style={crownStyle}>
          <CrownSvg fill={crownFill} />
        </div>
      )}
      <div className={classes.letter}>{letter}</div>
    </span>
  );
}
